export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-mute-035fab1205b4089de7ed8f2369161cbc.png";